import React, { useEffect } from "react";
import classes from "./E-cherha.module.scss";
import Heading from "../../../components/caseStudy/heading/Heading.tsx";
import Info, { Feature, Topic } from "../../../components/caseStudy/info/Info.tsx";
import logo from "./media/logo.svg";
import OtherProjects from "../../../components/caseStudy/other-projects/OtherProjects.tsx";
import { ECaseStudy } from "../../../enums/case-study.enum.ts";
import OrganizationSeo from "../../../components/Seo/OrganizationSeo.tsx";
import { useTranslation } from "react-i18next";


const ECherha = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const {t} = useTranslation();
    
    const title = [t('eCherha.title'), t('eCherha.blueTitle')]

    const description = [
        t('eCherha.text')
    ]

    const infoTitle = t('eCherha.info.title');

    const infoTitleMessage = t('eCherha.info.text')

    const topics: Topic[] = t('eCherha.topic', {returnObjects: true})

    const features: Feature = {
        list: t('eCherha.featuresList', {returnObjects: true})
    }

    const rightBlock = {
        platforms: t('eCherha.rightBlock.platforms', {returnObjects: true}),
        services: t('eCherha.rightBlock.services', {returnObjects: true}),
        audience: t('eCherha.rightBlock.audience', {returnObjects: true}),
        field: t('eCherha.rightBlock.field', {returnObjects: true})
    }

    return (
        <>
            <OrganizationSeo
                title="Goteco: Secure and Scalable GovTech and Business Solutions"
                description="Goteco specializes in developing secure, scalable systems that boost efficiency across public and private sectors, optimizing processes in manufacturing, e-commerce, and construction industries."
                url="https://go-te.co/"
                image="https://go-te.co/logo.svg"
            />

            <section className={classes.section} id="nav-dark">
                <Heading title={title} description={description} maxWidth={800} imageName={'e-cherha.webp'} />

                <Info
                    title={infoTitle}
                    titleMessage={infoTitleMessage}
                    topics={topics}
                    featuresText={t('eCherha.featuresText')}
                    features={features}
                    rightBlock={rightBlock}
                />

                <div className={classes["image-section"]}>
                    <div className={classes["overlay"]}></div>
                    <div className={classes["image-container"]}>
                        <img className={classes.logo} src={logo} alt="Electronic Queue logo" />
                        <div className={classes.text}>
                            {t('eCherha.bottomText')}
                        </div>
                    </div>
                </div>

                <OtherProjects name={ECaseStudy.E_CHERHA} />
            </section>
        </>
    );
};

export default ECherha;